import * as React from 'react';

export enum AlertType {
  Success = 'success',
  Error = 'danger',
  Warning = 'warning'
}

interface IAlertProps {
  type: AlertType;
}

export const Alert = ({ type, children }: React.PropsWithChildren<IAlertProps>) => (
  <div className={`alert alert-${type}`}>{children}</div>
);
